import { render, staticRenderFns } from "./JsonLd.vue?vue&type=template&id=50d97876&scoped=true&"
import script from "./JsonLd.vue?vue&type=script&lang=ts&"
export * from "./JsonLd.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50d97876",
  null
  
)

export default component.exports